import { render } from "./ArticleLayout.vue?vue&type=template&id=547df81b&scoped=true"
import script from "./ArticleLayout.vue?vue&type=script&lang=js"
export * from "./ArticleLayout.vue?vue&type=script&lang=js"

import "./ArticleLayout.vue?vue&type=style&index=0&id=547df81b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-547df81b"]])

export default __exports__